<template>
  <a v-if="imageSrc && link" target="_blank" :href="staticUrl">
    <b-img
      v-if="fluidGrow"
      :src="imageSrc"
      fluid-grow
      :alt="alt"
      :width="width"
      :height="height"
      :class="imageClass"
    />
    <b-img
      v-else
      :src="imageSrc"
      :width="!fitIn ? width : null"
      :height="!fitIn ? height : null"
      :alt="alt"
      :class="imageClass"
    />
  </a>
  <b-img
    v-else-if="imageSrc && fluidGrow"
    :src="imageSrc"
    fluid-grow
    :alt="alt"
    :width="width"
    :height="height"
    :class="imageClass"
  />
  <b-img
    v-else-if="imageSrc"
    :src="imageSrc"
    :width="!fitIn ? width : null"
    :height="!fitIn ? height : null"
    :alt="alt"
    :class="imageClass"
  />
</template>

<script>
import { scaleImageToDataUrl } from '@/lib/images.js'

export default {
  name: 'Thumbnail',
  props: {
    path: String,
    alt: String,
    watermark: { type: Boolean, default: false },
    watermarkHorizontalAlign: { type: String, default: 'left' }, // left | right
    watermarkVerticalAlign: { type: String, default: 'bottom' }, // bottom | top
    watermarkMargin: { type: Number, default: 50 },
    watermarkOpacity: { type: Number, default: 50 }, // 0 to 100
    fitIn: { type: Boolean, default: false },
    width: { type: Number, default: 40 },
    height: { type: Number, default: 40 },
    link: { type: Boolean, default: true },
    fluidGrow: { type: Boolean, default: false },
    showNoImage: { type: Boolean, default: false },
    preload: { type: Boolean, default: false },
    imageClass: { type: String },
    horizontalAlign: String,
    verticalAlign: String
  },
  data () {
    return {
      imageSrc: null
    }
  },
  computed: {
    staticUrl () {
      if (this.path) return `${this.$config.files.staticServerUrl}/${this.path}`
      else if (this.showNoImage) return this.$config.files.noImageUrl
      else return null
    },
    thumbUrl () {
      if (this.path) {
        const secs = [this.$config.files.thumbServerUrl]

        if (this.fitIn) secs.push('fit-in')

        secs.push(`${this.width}x${this.height}`)

        if (this.horizontalAlign && this.horizontalAlign !== 'center')
          secs.push(this.horizontalAlign)

        if (this.verticalAlign && this.verticalAlign !== 'middle')
          secs.push(this.verticalAlign)

        if (this.watermark) {
          const horizontalMargin =
            this.watermarkHorizontalAlign === 'left'
              ? this.watermarkMargin
              : -this.watermarkMargin
          const verticalMargin =
            this.watermarkVerticalAlign === 'top'
              ? this.watermarkMargin
              : -this.watermarkMargin
          secs.push(
            `filters:watermark(${
              this.$config.files.watermarkUrl
            }, ${horizontalMargin}, ${verticalMargin}, ${
              this.watermarkOpacity
            })`
          )
        }

        secs.push(`${this.$config.files.staticServerUrl}/${this.path}`)

        return secs.join('/')
      } else if (this.showNoImage) {
        return `${this.$config.files.thumbServerUrl}/${this.width}x${
          this.height
        }/${this.$config.files.noImageUrl}`
      } else return null
    }
  },
  watch: {
    staticUrl () {
      this.getImageSrc().then(url => {
        this.imageSrc = url
      })
    },
    thumbUrl () {
      this.getImageSrc().then(url => {
        this.imageSrc = url
      })
    }
  },
  mounted () {
    this.getImageSrc().then(url => {
      this.imageSrc = url
      if (this.preload) this.download()
    })
  },
  methods: {
    getImageSrc () {
      if (this.$config.files.thumbsAreEnabled) {
        return Promise.resolve(this.thumbUrl)
      } else {
        return scaleImageToDataUrl(this.staticUrl, this.width)
      }
    },
    download () {
      const img = new Image()
      img.onload = () => {
        this.$emit('preloaded', {
          width: img.width,
          height: img.height
        })
      }
      img.src = this.imageSrc
    }
  }
}
</script>
